import { ReactNode } from 'react'

import { preview } from '@/components/form/preview'

import { Box, Divider, Stack, Typography, styled } from '@mui/material'

import { useTexts } from './useTexts'

const Frame = styled(Box)({
  border: '1px solid #D3D7DC',
  padding: '16px',
})

type NotificationPreviewProps = {
  icon: ReactNode
  notificationType: string
  subject?: string
  templatePreview?: string
  additionalTextDetails?: string
}

export function NotificationPreview(props: NotificationPreviewProps) {
  const { icon, notificationType, subject, templatePreview, additionalTextDetails } = props

  const texts = useTexts()

  return (
    <Stack direction="column" spacing={1}>
      <Frame>
        <Stack direction="column" spacing={3}>
          <Stack direction="row" spacing={1} alignItems="center">
            {icon}
            <Typography variant="body1" data-testid="notification-type">
              {notificationType}
            </Typography>
          </Stack>

          <Divider />

          <Stack direction="column" spacing={4}>
            {subject && (
              <preview.Field testId="notification-subject" label={texts.subject}>
                {subject}
              </preview.Field>
            )}

            <Stack direction="column" spacing={1}>
              <preview.Field
                testId="notification-template"
                label={`${texts.text} ${additionalTextDetails ? `• ${additionalTextDetails}` : ''}`}
              >
                <preview.Template>{templatePreview}</preview.Template>
              </preview.Field>
            </Stack>
          </Stack>
        </Stack>
      </Frame>
      <preview.Label>{texts.helperText(notificationType)}</preview.Label>
    </Stack>
  )
}
